import styled from "styled-components";
 
export const Box = styled.div`
    padding: 5% 2.5%;
    background-color: rgba(29,78,216,0.75);
    //position: absolute;
    bottom: 0;
    width: 100%;
 
    @media (max-width: 1000px) {
        // padding: 70px 30px;
    }
`;
 
export const FooterContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    max-width: 1200px;
    margin: 0 auto;
    /* background: red; */
`;
 
export const Column = styled.div`
    display: flex;
    flex-direction: column;
    text-align: left;
    margin-left: 60px;
    );
    @media (max-width: 1000px) {
        margin: 0 auto;
    }
`;
 
export const Row = styled.div`
    display: grid;
    grid-template-columns: repeat(
        auto-fill,
        minmax(250px, 1fr)
    );
    grid-gap: 20px;
    @media (max-width: 1000px) {
        grid-template-columns: repeat(
            auto-fill,
            minmax(150px, 1fr)
        );
    }
`;
 
export const FooterLink = styled.a`
    color: #fff;
    margin-bottom: 15px;
    font-size: 16px;
    text-decoration: none;
 
    &:hover {
        color: black;
        transition: 200ms ease-in;
    }
`;
 
export const Heading = styled.p`
    font-size: 20px;
    color: #fff;
    margin-bottom: 30px;
    font-weight: bold;
`;